export const groups = [
    {
        label: 'Dla użytkownika',
        items: [
            {
                label: 'Zasady pisania opinii',
                href: '/i/dla-uzytkownika/zasady-pisania-opinii'
            },
            {
                label: 'Wiarygodne Opinie',
                href: '/i/dla-uzytkownika/wiarygodne-opinie'
            },
            {
                label: 'Pytania (FAQ)',
                href: '/i/dla-uzytkownika/pytania-faq'
            },
            {
                label: 'Polityka prywatności',
                href: 'https://polityka-prywatnosci.onet.pl/index.html'
            },
            {
                label: 'Regulamin dla użytkowników<br>(aktualizacja z dniem 17.02.2024)',
                href: '/i/dla-uzytkownika/regulamin-dla-uzytkownikow-serwisu'
            },
            {
                label: 'Akt o Usługach Cyfrowych - informacja',
                href: '/i/dla-uzytkownika/akt-o-uslugach-cyfrowych-informacja'
            }
        ]
    },
    {
        label: 'Dla sklepów',
        items: [
            {
                label: 'Jak zacząć współpracę?',
                href: '/i/dla-firm/jak-zaczac-wspolprace'
            },
            {
                label: 'Słucham swoich klientów',
                href: 'https://odznaki.opineo.pl/'
            },
            {
                label: 'System wiarygodne opinie',
                href: 'https://dolacz.opineo.pl/#wiarygodne-opinie'
            },
            {
                label: 'Regulamin',
                href: '/i/dla-firm/regulamindlapodmiotowwspolpracujacych'
            }
        ]
    },
    {
        label: 'Dla Firm',
        items: [
            {
                label: 'Jak zacząć współpracę?',
                href: '/i/dla-firm/jak-zaczac-wspolprace'
            },
            {
                label: 'Regulamin',
                href: '/i/dla-firm/regulamindlapodmiotowwspolpracujacych'
            },
            {
                label: 'Słucham swoich klientów',
                href: 'https://odznaki.opineo.pl/'
            },
            {
                label: 'Panel dla firm',
                href: 'https://panel.opineo.pl'
            }
        ]
    }
] as {
    label: string;
    items: {
        label: string;
        href: string;
    }[];
}[];
